import axios from "axios";
const API_HOST='https://vps-150f6958.vps.ovh.net'
//const API_HOST='http://localhost:8081'
const axiosInstance =axios.create({
    baseURL: API_HOST

});
axiosInstance.API_HOST=API_HOST

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("user")).accessKey;
    
    config.headers.Authorization =`Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use( (response)=> {

  return response
},  (error) =>{
  console.log(error.response.data)

  if (error.response.status === 401) {   
    localStorage.removeItem("user")
    //window.location.href="/"    
  }
  return Promise.reject(error)
})
 export default axiosInstance;
